<template>
  <div>
    <div class="mt-3 mb-2 pr-2 pl-2">
      <div class="d-flex align-items-center">
        <h1 class="title-section-info">Checkout</h1>
        <!-- Desactivar el checkbox, mientras no haya terminado la configuracion -->
        <b-form-checkbox v-if="isAdmin" switch class="checkbox-switch switch-webhook checkbox-company"
          v-model="form.activated" :disabled="finishedSettings">
          <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
        </b-form-checkbox>
        <div v-else class="d-flex align-items-center">
          <span class="table_dot--company mr-50" :class="getStatusClass(form.activated)"></span>
          <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
        </div>
      </div>
    </div>

    <div class="col-12 mt-2 mb-3">
      <p class="m-0">Personaliza tu <strong>'Checkout'</strong> para que refleje la identidad de tu tienda. Sube tu
        logotipo, elige colores y define las opciones de entrega disponibles. Revisa una vista previa antes de
        activarlo.</p>
    </div>

    <b-card>
      <div class="tab-header-content">
        <b-tabs ref="checkoutTabs" v-model="activeTab" fill>
          <b-tab>
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 0 ? 'primary' : 'secondary'" class="mr-1">1</b-avatar>
              {{ $t('Logotipo') }}
            </template>
            <TabLogotipoLoader v-if="company_data && company_data.company && company_data.company.id"
              :company_data="company_data" :setUserInSession="setUserInSession"
              :loadingInfoCompany="loading.companyInfo" @continuar="goToTab(1)" />
          </b-tab>
          <b-tab :disabled="!company_data || !company_data.company || !company_data.company.id">
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 1 ? 'primary' : 'secondary'" class="mr-1">2</b-avatar>
              {{ $t('Colores') }}
            </template>
            <TabColorsPicker @colors-customized="onColorsCustomized" @continuar="goToTab(2)"
              :can-continue="colorsCustomized"></TabColorsPicker>
          </b-tab>
          <b-tab :disabled="!colorsCustomized">
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 2 ? 'primary' : 'secondary'" class="mr-1">3</b-avatar>
              {{ $t('Entrega') }}
            </template>
            <TabDelivery @delivery-customized="onDeliveryCustomized" @continuar="goToTab(3)"
              :can-continue="deliveryCustomized"></TabDelivery>
          </b-tab>
          <b-tab :disabled="!deliveryCustomized">
            <template #title>
              <b-avatar size="sm" :variant="activeTab === 3 ? 'primary' : 'secondary'" class="mr-1">4</b-avatar>
              {{ $t('Vista previa') }}
            </template>
            <TabPreview></TabPreview>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </div>
</template>
<script>
import TabLogotipoLoader from './tabs/TabLogotipoLoader.vue'
import TabColorsPicker from './tabs/TabColorsPicker.vue'
import TabDelivery from './tabs/TabDelivery.vue'
import TabPreview from './tabs/TabPreview.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'TabNotify',
  components: {
    TabLogotipoLoader,
    TabColorsPicker,
    TabDelivery,
    TabPreview
  },
  data () {
    return {
      form: {
        activated: false
      },
      company_id: this.$route.params?.id,
      loading: {
        companyInfo: true,
        companyInfoSkeleton: true
      },
      setUserInSession: {},
      company_data: null,
      isAdmin: false,
      refresh_company_data: null,
      colorsCustomized: false,
      deliveryCustomized: false,
      activeTab: 0
    }
  },
  methods: {
    setInitialData () {
      this.isAdmin = ['superadmin', 'admin'].includes(this.mySession?.role)
    },
    getStatusClass(activated) {
      return activated ? 'table_dot--company-ok' : 'table_dot--company-inactivated'
    },
    getCompanyInfo() {
      this.$store.dispatch('fetchService', { name: 'getCompanyInformation', params: {company_id: this.company_id}})
    },
    getCompanyInfoEdition () {
      this.getCompanyInfo()
    },
    async loadCompanyData() {
      const response = await this.$store.dispatch('fetchService', { name: 'getCompanyInformation', params: {company_id: this.company_id}}) // tu llamada real
      this.company_data = { company: response.data }
    },
    goToTab(index) {
      this.activeTab = index
    },
    onLogotipoCustomized(val) {
      this.logotipoCustomized = val
    },
    onColorsCustomized(val) {
      this.colorsCustomized = val
    },
    onDeliveryCustomized(val) {
      this.deliveryCustomized = val
    }
  },
  mounted () {
    this.setInitialData()
    this.loadCompanyData()
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      companyInfo: 'getCompanyInformation',
      generalLoading: 'getLoading'
    }),
    finishedSettings() {
      // TODO: Implementar la lógica para verificar si todos los pasos están completos
      return !(
        this.company_data &&
        this.company_data.company &&
        this.company_data.company.id &&
        this.colorsCustomized &&
        this.deliveryCustomized &&
        this.activeTab === 3
      )
    }
  },
  watch: {
    companyInfo() {
      if (!!this.companyInfo?.data) {
        this.company_data = this.companyInfo.data
        this.company_data.validate_authority_contacts = false
        this.loading.companyInfoSkeleton = false
      }
    },
    generalLoading: {
      handler () {
        this.loading.companyInfo = !!this.generalLoading.getCompanyInformation
      }
    }
  }
}
</script>
<style>
  .table_dot--company-ok{
    background-color:#5CB30B
  }
  .table_dot--company-inactivated{
    background-color:#D1DADE
  }
</style>